// RegistrationSuccess.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';

const RegistrationSuccess = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: theme.palette.background.default
    }}>
      <Paper sx={{
        padding: 4,
        maxWidth: '500px',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper
      }}>
        <EmailIcon sx={{ 
          fontSize: 60, 
          color: theme.palette.primary.main,
          mb: 2 
        }} />
        <Typography variant="h5" gutterBottom>
          {t('registration.successTitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('registration.successMessage')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default RegistrationSuccess;